import { Component } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { OrdersService } from '../orders.service';

@Component({
  templateUrl: './decline-dialog.component.html',
  styleUrls: ['./decline-dialog.component.scss'],
  standalone: false,
})
export class DeclineDialogComponent {
  declineLoading = false;
  message: UntypedFormControl = new UntypedFormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<DeclineDialogComponent>,
    private translateService: TranslateService,
    private snackbarService: SnackbarService,
    public ordersService: OrdersService,
  ) {}

  onDecline(): void {
    if (this.message.valid) {
      if (this.declineLoading) {
        return;
      }

      this.declineLoading = true;
      this.ordersService
        .decline(this.message.value)
        .pipe(
          take(1),
          map((o) => {
            this.declineLoading = false;
            this.dialogRef.close(o);
          }),
          catchError((err) => {
            this.declineLoading = false;
            this.snackbarService.openErrorSnack('STORE.DECLINE_ORDER.ERROR');
            return of(err);
          }),
        )
        .subscribe();
    }
  }

  getErrorMessage(): string {
    return this.message.hasError('required')
      ? this.translateService.instant('FRONTEND.SALES_UI.DECLINE_MESSAGE_VALIDATION')
      : '';
  }
}
